import { render, staticRenderFns } from "./info_detail.vue?vue&type=template&id=03c096d5&scoped=true&"
import script from "./info_detail.vue?vue&type=script&lang=js&"
export * from "./info_detail.vue?vue&type=script&lang=js&"
import style0 from "./info_detail.vue?vue&type=style&index=0&id=03c096d5&lang=less&scoped=true&"
import style1 from "./info_detail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c096d5",
  null
  
)

export default component.exports